import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";

interface Props {
  onSubmit: (emailBlock: string) => void;
  error: string | null;
  text: string;
  onTextChange: (text: string) => void;
  isLoading: boolean;
}

export function CreateFollowRequest(props: Props) {
  const { onSubmit, error, text, onTextChange, isLoading } = props;

  return (
    <Box
      border={1}
      borderColor="divider"
      bgcolor="grey.100"
      borderRadius={1}
      p="1rem"
      flex={1}
      mt=".5rem"
    >
      <Typography variant="h6">Add Carriers to Your Network</Typography>
      <Typography variant="body2" mb="1rem">
        Enter a single email or a list of emails. Emails must be separated by
        commas.
      </Typography>
      <TextField
        placeholder="ltl-carrier@example.com, dry-van-carrier@example.com"
        multiline
        fullWidth
        value={text}
        onChange={(e) => onTextChange(e.target.value)}
        sx={{ backgroundColor: "background.paper" }}
      />
      {error && (
        <Typography mt="1rem" color="red">
          {error}
        </Typography>
      )}
      <Box mt="1rem">
        {!isLoading && (
          <Button variant="contained" onClick={() => onSubmit(text)}>
            Add Carriers
          </Button>
        )}
        {isLoading && <CircularProgress />}
      </Box>
    </Box>
  );
}
